import reducer from '.'
import menuApi from './menu.service'
import { getActiveClientId } from '../clients/selectors'
import type { RootState } from '../store'

// endpoint.select(arg) builds a *new* memoized selector each call; reusing one
// instance per arg keeps the returned result reference stable so consumers don't
// rerender on every state change.
const menuResultSelectorByClient = new Map<
  string | null,
  ReturnType<typeof menuApi.endpoints.getMenu.select>
>()

const getMenuResultSelector = (id: string | null) => {
  let selector = menuResultSelectorByClient.get(id)
  if (!selector) {
    selector = menuApi.endpoints.getMenu.select(id)
    menuResultSelectorByClient.set(id, selector)
  }
  return selector
}

export const getMenu = (state: RootState) =>
  getMenuResultSelector(getActiveClientId(state))(state)

export const getMenuStates = (state: RootState) => state[reducer.name]
